import { format } from 'date-fns';
import { getUTCDateFromMilliseconds } from '../../../shared/utils/smartutils';

export default function columns(t) {
  return [
    { title: t('general.product'), field: 'product.name' },
    { title: t('general.category'), field: 'category.name' },
    { title: t('general.amount'), field: 'quantity' },
    {
      title: t('general.percentage-discount'),
      field: 'discountPercentage',
    },
    {
      title: t('general.unit-value'),
      field: 'unitaryValue',
      render: (rowData) =>
        rowData.unitaryValue.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
    { title: t('general.quota'), field: 'numberOfInstallments' },
    { title: t('general.charging-freq'), field: 'paymentFrequency.name' },
    {
      title: t('general.due-date-day'),
      field: 'firstDueDate',
      render: (rowData) =>
        format(getUTCDateFromMilliseconds(rowData.firstDueDate), 'dd/MM/yyyy'),
    },
    {
      title: t('general.subtotal'),
      field: 'amount',
      render: (rowData) =>
        rowData.amount.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        }),
    },
  ];
}
